<nav class="layout-sidebar shadow-sm border border-[var(--border-default)]" aria-label="Main">
    <ul class="layout-menu layout-menu-main">
        @for (item of model(); track item; let i = $index) {
            <li app-admin-menuitem [item]="item" [index]="i" [root]="true"></li>
        }
    </ul>
</nav>
